import { render } from "./FieldHeader.vue?vue&type=template&id=faad9b78"
import script from "./FieldHeader.vue?vue&type=script&lang=js"
export * from "./FieldHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__